import React from "react";
import "./FleetCoreAccountabilityLoop.css";

import fleetcoreAccountabilityLoopDesktopSequence from "../../images/fleetcore-accountability-loop-desktop-sequence.svg";
import fleetcoreAccountabilityLoopMobileSequence from "../../images/fleetcore-accountability-loop-mobile-sequence.svg";

export default function FleetCoreAccountabilityLoop() {
  return (
    <section className="fleetcore-accountability-loop" id="fleetcore-accountability-loop" aria-labelledby="fleetcore-accountability-loop-title">
      <div className="fleetcore-accountability-loop__inner">
        <div className="fleetcore-accountability-loop__intro">
          <div><p className="fleetcore-accountability-loop__eyebrow">ONE CONTINUOUS EVIDENCE TRAIL</p><h2 id="fleetcore-accountability-loop-title">Connect the full fleet event—not isolated records.</h2></div>
          <p className="fleetcore-accountability-loop__body">FleetCore keeps the driver, vehicle, shift, fuel and resulting action connected to the same operational event.</p>
        </div>
        <img className="fleetcore-accountability-loop__desktop-model" src={fleetcoreAccountabilityLoopDesktopSequence} alt="Driver, vehicle, shift, fuel, intelligence and action connected in the FleetCore accountability loop" />
        <img className="fleetcore-accountability-loop__mobile-model" src={fleetcoreAccountabilityLoopMobileSequence} alt="Vertical FleetCore accountability loop from driver evidence to management action" />
        <p className="fleetcore-accountability-loop__principle">Evidence becomes useful when every event remains connected.</p>
      </div>
    </section>
  );
}
